import { Theme } from '@mui/material';
import { LabelTagBoxVariant } from './types';

type LabelTagBoxColors = {
  background: string;
  color: string;
  borderColor: string;
};

const getAlarmColors = (
  theme: Theme,
  enableColorCoding: boolean,
  colorCoding?: string
): LabelTagBoxColors => {
  if (!enableColorCoding) {
    return {
      background: theme.palette.grey[300],
      color: '#3B3B3B',
      borderColor: 'transparent',
    };
  }

  if (!colorCoding) {
    return {
      background: theme.palette.success.lighter,
      color: '#3B3B3B',
      borderColor: theme.palette.success.main,
    };
  }

  const colorMap: Record<string, LabelTagBoxColors> = {
    critical: {
      background: theme.palette.error.lighter,
      color: '#3B3B3B',
      borderColor: theme.palette.error.main,
    },
    warning: {
      background: theme.palette.warning.lighter,
      color: '#3B3B3B',
      borderColor: theme.palette.warning.main,
    },
    info: {
      background: theme.palette.info.lighter,
      color: '#3B3B3B',
      borderColor: theme.palette.info.main,
    },
  };

  return colorMap[colorCoding];
};

const getStateColors = (isOperational: boolean): LabelTagBoxColors => ({
  background: isOperational ? 'rgba(5, 182, 178, 0.08)' : '#DFE3E8',
  color: isOperational ? '#05B6B2' : '#212B36',
  borderColor: 'transparent',
});

export const getLabelTagBoxColors = (
  theme: Theme,
  variantProps: LabelTagBoxVariant
): LabelTagBoxColors => {
  switch (variantProps.variant) {
    case 'state':
      return getStateColors(variantProps.isOperational);
    case 'alarm':
      return getAlarmColors(theme, variantProps.enableColorCoding, variantProps.colorCoding);
  }
};
